import React from 'react';

import {
  KPAnswersTeasers,
  Loader,
} from '../../../components';

import './style.scss';

const ViewKPAnswersAll = ({ onLoadMore, pager, loading, entities }) => {
  return (
    <div className="View ViewKPAnswersAll NewsSelection">
      <div className="row">
        <KPAnswersTeasers entities={entities} />
      </div>
      <Loader loading={loading} />
    </div>
  );
};

export default ViewKPAnswersAll;
